/* eslint-disable camelcase */
import { CANDIDATE_OFFER_ACCEPT_CONTEXT } from '../../pages/candidateOfferList/constants';
import { ErrorTypes } from '../api/error';

const CUSTOMER_PAGE_CONTEXT = 'CUSTOMER_PAGE_CONTEXT' as const;
const CUSTOMER_PAGE_FINAL_CONTEXT = 'CUSTOMER_PAGE_FINAL_CONTEXT' as const;

const translations = {
    en: {
        [ `100052_${ CUSTOMER_PAGE_CONTEXT }` as const ]: 'The data was outdated and has been refreshed. Please review the updated data and resubmit.',
        [ `100052_${ CUSTOMER_PAGE_FINAL_CONTEXT }` as const ]: 'The data was outdated and has been refreshed. This page shows the finalized selection of candidates and shifts assigned to this order.',
        [ `100052_${ CANDIDATE_OFFER_ACCEPT_CONTEXT }` as const ]: 'This opportunity has just changed or is no longer available. Please refresh the page to see the latest information. If you still can’t continue, contact {{tenantName}}.',
        [ ErrorTypes.OrderNoLongerAvailable ]: 'This job is no longer available.',
        ['100115']: 'Could not find assignment. It may have been removed. Please refresh the page to see the latest information. If you still can\'t continue, contact {{tenantName}}.',
        [ ErrorTypes.General ]: 'Something went wrong. Please refresh the page and try again. If the problem persists, please contact {{tenantName}} support and we will help you.',
        [ ErrorTypes.Timeout ]: 'Unfortunately the connection was interrupted. Please check your network connection and try again. If the problem persists, please contact {{tenantName}} support, and we will help you.',
        [ ErrorTypes.Connection ]: 'Unfortunately the connection was interrupted. Please check your network connection and try again. If the problem persists, please contact {{tenantName}} support, and we will help you.',
        [ ErrorTypes.ServerError ]: 'Unfortunately something happened and an error was received from the Server. Please check your connection and try again. If the problem persists, please contact {{tenantName}} support and we will help you.',
        general: {
            title: 'Something went wrong',
            description: 'Please refresh the page and try again. If the problem persists, please contact {{tenantName}} support and we will help you.',
            switchToClassic: 'Switch to Classic Version'
        },
        title: {
            loadFailed: 'Failed to load data',
            ['100115']: 'Assignment not found'
        }
    },
    no: {
        [ `100052_${ CANDIDATE_OFFER_ACCEPT_CONTEXT }` as const ]: 'Oppdraget er endret eller ikke lenger tilgjengelig. Last inn siden på nytt for å se oppdatert informasjon. Kontakt {{tenantName}} hvis du fortsatt ikke kommer videre.',
        [ ErrorTypes.OrderNoLongerAvailable ]: 'Denne jobben er ikke lenger tilgjengelig.',
        ['100115']: 'Kunne ikke finne oppdraget. Det kan ha blitt fjernet. Oppdater siden for å se den nyeste informasjonen. Hvis du fortsatt ikke kommer videre, kontakt {{tenantName}}.',
        [ ErrorTypes.General ]: 'Noe gikk galt. Oppdater siden og forsøk igjen. Hvis problemet vedvarer, gi oss beskjed og vil hjelpe deg.', 
        [ ErrorTypes.Timeout ]: 'Tilkoblingen ble avbrutt. Sjekk internettilkoblingen din og forsøk igjen. Hvis problemet vedvarer, vennligst kontakt oss, og vi vil hjelpe deg.', 
        [ ErrorTypes.Connection ]: 'Tilkoblingen ble avbrutt. Sjekk internettilkoblingen din og forsøk igjen. Hvis problemet vedvarer, vennligst kontakt oss, og vi vil hjelpe deg.', 
        [ ErrorTypes.ServerError ]: 'Noe gikk galt og vi mottok en feilmelding fra serveren. Vennligst sjekk internettilkoblingen din og forsøk igjen. Hvis problemet vedvarer, ta kontakt med oss og vi vil hjelpe deg.', 
        general: {
            title: 'Noe gikk galt',
            description: 'Oppdater siden og forsøk igjen. Hvis problemet vedvarer, ta kontakt med oss og vi vil hjelpe deg.',
            switchToClassic: 'Bytt til klassisk versjon'
        },
        title: {
            loadFailed: 'Kunne ikke laste data',
            ['100115']: 'Oppdrag ikke funnet'
        }
    },
    sv: {
        [ `100052_${ CANDIDATE_OFFER_ACCEPT_CONTEXT }` as const ]: 'Uppdraget har ändrats eller är inte längre tillgängligt. Uppdatera sidan för att se den senaste informationen. Kontakta {{tenantName}} om du fortfarande inte kan fortsätta.',
        [ ErrorTypes.OrderNoLongerAvailable ]: 'Det här avropet är inte längre tillgängligt.',
        ['100115']: 'Kunde inte hitta uppdraget. Det kan ha tagits bort. Uppdatera sidan för att se den senaste informationen. Om du fortfarande inte kan fortsätta, kontakta {{tenantName}}.',
        [ ErrorTypes.General ]: 'Något gick fel. Uppdatera sidan och försök igen. Om problemet kvarstår, kontakta {{tenantName}} Support så hjälper vi dig.',
        [ ErrorTypes.Timeout ]: 'Tyvärr avbröts anslutningen. Kontrollera din iInternetuppkoppling och försök igen. Om problement kvarstår, kontakta {{tenantName}} Support så hjälper vi dig.',
        [ ErrorTypes.Connection ]: 'Tyvärr avbröts anslutningen. Kontrollera din iInternetuppkoppling och försök igen. Om problement kvarstår, kontakta {{tenantName}} Support så hjälper vi dig.', 
        [ ErrorTypes.ServerError ]: 'Något gick fel och ett felmeddelande togs emot från servern. Kontrollera din iInternetuppkoppling och försök igen. Om problemet kvarstår, kontakta {{tenantName}} Support så hjälper vi dig.', 
        general: {
            title: 'Något gick fel',
            title_load: 'Kunde inte ladda data',
            description: 'Något gick fel. Uppdatera sidan och försök igen. Om problemet kvarstår, kontakta {{tenantName}} Support så hjälper vi dig.',
            switchToClassic: 'Byt till klassisk version'
        },
        title: {
            loadFailed: 'Kunde inte ladda data',
            ['100115']: 'Uppdraget hittades inte'
        }
    }
} as const;

export type ErrorTranslationKey = keyof typeof translations.en;

export default translations;

export {
    CUSTOMER_PAGE_CONTEXT,
    CUSTOMER_PAGE_FINAL_CONTEXT
};
